export const OVERPAYMENTS_URL = '/matching/overpayments'

export const OVERPAYMENT_API = '/api/internal/overpayment'
export const OVERPAYMENT_REASON_LOOKUP_API = '/api/internal/overpayment-reason/lookup'
export const CASH_BOX_PAYOUT_LOOKUP_API = '/api/internal/cash-box/payout-lookup'

export const PAY_VIA_LOCAL_ADAPTER_LABEL = 'Оплатить через локальный адаптер'

/** Подпись под бейджем статуса у записи, чья компенсационная выплата ушла на кассу */
export const VIA_CASH_BOX_LABEL = 'через кассу'

// Подписи отказов «Оплатить через локальный адаптер» по errorCode ответа. Код без подписи
// показывается текстом бэкенда — по нему причину можно найти в логах.
export const LOCAL_ADAPTER_ERROR_LABEL: Record<string, string> = {
  OVERPAYMENT_PAYOUT_NOT_IN_MATCHING: 'Выплата уже не в мэтчинге',
  OVERPAYMENT_CASHBOX_UNAVAILABLE: 'Касса недоступна: отключена или заблокирована',
  CASHBOX_INSUFFICIENT_BALANCE: 'У кассы не хватает остатка с учётом овердрафта на эту выплату',
  OVERPAYMENT_DEPOSIT_IN_PROGRESS: 'По выплате идёт незавершённый депозит',
  OVERPAYMENT_PARTIALLY_COVERED: 'По выплате уже есть оплаченный депозит',
  OVERPAYMENT_ALREADY_PAID: 'Выплата уже оплачена мэтчингом',
  OVERPAYMENT_PLACEMENT_FAILED: 'Касса не приняла выплату, переоплата отменена — заведите новую',
  OVERPAYMENT_WITHDRAWN_NOT_PLACED: 'Выплата снята с мэтчинга, но на кассу не встала — повторите действие',
  OVERPAYMENT_LOCAL_ADAPTER_MISSING: 'Локальный адаптер не настроен',
  MATCHING_UNAVAILABLE: 'Мэтчинг недоступен, попробуйте позже',
  OVERPAYMENT_NOT_FOUND: 'Переоплата не найдена или недоступна',
}

export const LOCAL_ADAPTER_ERROR_FALLBACK = 'Не удалось провести переоплату через локальный адаптер'

// Подписи отказов создания переоплаты по errorCode ответа. OVERPAYMENT_ORIGINAL_PAYOUT_INCOMPLETE
// подписи не имеет намеренно: текст бэкенда перечисляет, каких данных не хватает.
export const OVERPAYMENT_CREATE_ERROR_LABEL: Record<string, string> = {
  OVERPAYMENT_IN_PROGRESS: 'По этому депозиту уже есть переоплата, выплата которой ещё не завершена',
  OVERPAYMENT_DEPOSIT_NOT_COMPLETED: 'Депозит ещё не завершён — переоплата недоступна',
  OVERPAYMENT_PAYOUT_DECLINED: 'Исходная выплата уже в финальном статусе — переоплата недоступна',
  PAYOUT_NO_ADAPTERS_AVAILABLE:
    'Не удалось создать компенсационную выплату: нет доступного адаптера для выплаты. Обратитесь к администратору.',
  OVERPAYMENT_REASON_NOT_FOUND: 'Причина переоплаты не найдена — обновите страницу и выберите причину заново',
  OVERPAYMENT_REASON_DISABLED: 'Причина переоплаты отключена — выберите другую',
  OVERPAYMENT_SOURCE_NOT_FOUND: 'Сделка мэтчинга не найдена или недоступна',
}

export const OVERPAYMENT_CREATE_ERROR_FALLBACK = 'Не удалось создать переоплату'

export const UI_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
} as const

export const UI_STATUS_LABEL: Record<keyof typeof UI_STATUS, string> = {
  IN_PROGRESS: 'В работе',
  COMPLETED: 'Завершена',
  DECLINED: 'Отменена',
}

export const OVERPAYMENTS_BREADCRUMBS = [
  { title: 'Мэтчинг', path: '/matching' },
  { title: 'Переоплаты', path: OVERPAYMENTS_URL },
]
